function FaqList(questionElements, answerElements) {
	if (questionElements.length) {
		questionElements = [].slice.call(questionElements);
	}

	if (answerElements.length) {
		answerElements = [].slice.call(answerElements);
	}

	// binds
	this.toggle = this.toggle.bind(this);
	this.onResize = this.onResize.bind(this);

	this.callbacks = {
		onFaqOpened: []
	};

	// eventDistpatcher
	this.eventDispatcher = document.createElement('div');// hacky

	this.events = [];

	this.events.questionOpened = new CustomEvent('question-opened');

	this.faq = [];

	for(let i=0;i<questionElements.length;i++) {
		let base = questionElements[i].nextSibling;
		let question = null;
		while(base && base.nodeType !== 1){
			base = base.nextSibling;
		}

		if(answerElements.indexOf(base) >= 0){
			question = base;
		}

		this.faq.push({
			'question' : questionElements[i],
			'answer' : question,
			'answerHeight' : question.offsetHeight
		});
	}
}

FaqList.prototype.init = function() {
	for(let i=0;i<this.faq.length;i++){
		this.faq[i].question.addEventListener('click', event => {
			if(event.currentTarget){
				this.toggle(event.currentTarget);
			}
		});

		if (window.location.hash.substr(1) == this.faq[i].question.getAttribute('data-faq-slug') || this.faq[i].question.classList.contains('is-open')) {
			this.openFaq(this.faq[i]);
		}

		if (!this.faq[i].question.classList.contains('is-open')) {
			this.closeFaq(this.faq[i]);
		}

		this.faq[i].answer.addEventListener('transitionend', event => {
			if (event.target.classList.contains('is-open')) {
				this.eventDispatcher.dispatchEvent(this.events.questionOpened);
			}
		});
	}

	window.addEventListener('resize', this.onResize);
};

FaqList.prototype.getOpenFaqs = function() {
	return this.faq.filter(faq => faq.question.classList.contains('is-open'));
};

FaqList.prototype.toggle = function(target) {
	for(let i=0;i<this.faq.length;i++){
		if(target && target == this.faq[i].question && this.faq[i].question.classList.contains('is-closed')) {
			this.openFaq(this.faq[i]);
		}
		else if(target && target == this.faq[i].question) {
			this.closeFaq(this.faq[i]);
		}
	}
};

FaqList.prototype.openFaq = function(faq) {
	faq.question.classList.add('is-open');
	faq.question.classList.remove('is-closed');
	faq.answer.classList.add('is-open');
	faq.answer.classList.remove('is-closed');
	faq.answer.style.height = faq.answerHeight + 'px';

	if (faq.question.hasAttribute('data-faq-slug')) {
		window.history.replaceState(
			{
				faqSlug: faq.question.getAttribute('data-faq-slug')
			},
			faq.question.getAttribute('data-faq-slug'),
			'#' + faq.question.getAttribute('data-faq-slug')
		);
	}

	this.callbacks.onFaqOpened.forEach(callback => callback(faq));
};

FaqList.prototype.closeFaq = function(faq) {
	faq.question.classList.remove('is-open');
	faq.question.classList.add('is-closed');
	faq.answer.classList.remove('is-open');
	faq.answer.classList.add('is-closed');
	faq.answer.style.height = '0px';
}

FaqList.prototype.onResize = function() {
	for(let i=0;i<this.faq.length;i++){
		this.faq[i].answer.style.height = 'auto';
		this.faq[i].answerHeight = this.faq[i].answer.offsetHeight;
		if(this.faq[i].answer.classList.contains('is-closed')){
			this.faq[i].answer.style.height = '0px';
		}
		else {
			this.faq[i].answer.style.height = this.faq[i].answerHeight + 'px';
		}
	}
};

FaqList.prototype.setFaqOpenedCallback = function(callback) {
	this.callbacks.onFaqOpened.push(callback);
};

export default FaqList;